import { render, staticRenderFns } from "./TemplateEMAIL1.vue?vue&type=template&id=99a77ce4&scoped=true&"
import script from "./TemplateEMAIL1.vue?vue&type=script&lang=js&"
export * from "./TemplateEMAIL1.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEMAIL1.vue?vue&type=style&index=0&id=99a77ce4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a77ce4",
  null
  
)

export default component.exports